import { UserOutlined } from "@ant-design/icons";
import { radius } from "@libertify/ui";

export const ClonedFacePreview = ({ faceUrl }: { faceUrl: string }) => {
  return (
    <div
      style={{
        flex: "1 1 0",
        minHeight: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {faceUrl ? (
        <img
          src={faceUrl ?? ""}
          alt="Cloned face preview"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            aspectRatio: "1 / 1",
            objectFit: "cover",
            borderRadius: radius.box,
          }}
        />
      ) : (
        <UserOutlined style={{ fontSize: 100 }} />
      )}
    </div>
  );
};
